/* global axios */

import ApiClient from './ApiClient';

class WebHooks extends ApiClient {
  constructor() {
    super('webhooks', { accountScoped: true });
  }

  resetCustomHeaderToken(id) {
    return axios.post(`${this.url}/${id}/reset_custom_header_token`);
  }
}

export default new WebHooks();
